/**
* @Component Name: CreditCheckComponent
* @Module: Home
* @Module Functionality : To display the customer credit check information
* @Creation Date: August 12,2017
* @Author: sbaireddy
* @Version: 1.0
*/

import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import Utils from '../shared/utils';
import CartUtils from '../shared/cart.utils';
import { STATES, ID_TYPE, ID_STATES } from '../shared/form.constants';
import * as Constants from '../shared/constants';
import { User } from '../shared/modal/user';
import { Cart } from '../shared/modal/cart';
import {Customer, ICreditCheck, ICreditProfile} from '../shared/modal/customer';
import { SharedService } from '../shared/shared.service';
import { UserService } from '../services/user.service';
import { CartService } from '../services/cart.service';
import { CustomerService } from '../services/customer.service';
import * as _ from 'underscore'; // To do complex array and object functions
import { IDormantProperties } from '../shared/modal/common';

@Component({
    //moduleId: module.id,
    selector: 'credit-check-cmp',
    templateUrl: 'credit-check.component.html',
    styleUrls: ['credit-check.component.css']
})

// export class CreditCheckComponent implements OnInit, OnChanges, OnDestroy {
export class CreditCheckComponent implements OnInit, OnDestroy {
    private COMPONENT_NAME: string = 'CreditCheckComponent';
    karmaTestResult: any = {};
    stateItems: any[];
    idTypeItems: any[];
    bdStoreId: number = Constants.STORE_ID_BD;
    rtStoreId: number = Constants.STORE_ID_RT;
    cdStoreId: number = Constants.STORE_ID_CD;
    csStoreId: number = Constants.STORE_ID_CS;
    @Input() creditType: string;
    @Input() customerModel: any; // getting the customer address info from customer component.
    @Input() customerForm: any;
    @Output() onResetForm = new EventEmitter<boolean>();

    storeId: number; // update storeid
    creditCheckModel: any = { idExpiration: '', idIssuedState: '', idNumber: '', idType: '',
        employeeId: '', isEnglish: true, errormsg: '', yesAuthorize: false};
    dob: string;
    birthYear: number;
    expirationYear: number;
    expiration: number;
    isDateValid: boolean;
    minAllowedDate: any;
    user: User;
    cart: Cart;
    subscription: any;
    hasItemsInCart: boolean = false;
    isDealerCodeExists: boolean;
    maxdate: any;
    @ViewChild('conflictModel') conflictModel: any;
    disablePIN: boolean = false;
    today = new Date();
    eligibleAge = this.today.getFullYear() - 100;
    type: string = 'password';
    clearAllStatus: boolean = false;
    isEmployee:boolean= false;
    isUnderAge:boolean= false;
    isPreScreenFailure:boolean=false;
    dormantProperties: IDormantProperties;
    disableSsn3: boolean = false;
    public prescreenEnabled : boolean;

    constructor(
        public sharedService: SharedService,
        public userService: UserService,
        public cartService: CartService,
        public customerService: CustomerService) {
    }

    /**
    * This function is used to initialize the directive/component after Angular
    * first displays the data-bound properties.It is invoked only once when the
    * directive is instantiated.Here it is initializing all the states, ID Types, user and cart informations
    * @return {void}
    */
    ngOnInit(): void {
        const METHOD_NAME: string = 'ngOnInit()'; 
        // Start-Switch Channel-Store id update
        this.sharedService.updateErrorMessage(null);
        this.creditCheckModel.idIssuedState = '';
        this.creditCheckModel.idType = '';
        this.sharedService.storeId.subscribe((val: number) => {
            this.storeId = val;
            this.maxdate = new Date().getFullYear() + 18 + '-12';
        });
        // End-Switch Channel-Store id update
        // US267571: changed to ID_STATES constant to include Puerto Rico ID state.
        this.stateItems = ID_STATES.filter(stateItem => stateItem);
        this.idTypeItems = ID_TYPE.filter(idTypeItem => idTypeItem);
        this.user = this.userService.getUser();
        this.cart = this.cartService.getCart();
        this.subscription = this.cartService.hasUpdate.subscribe((item) => {
            if (item) { this.cart = this.cartService.getCart(); }
        });
        if (this.cart && this.cart.packages && this.cart.packages.length > 0) {
            this.hasItemsInCart = true;
        }
        this.sharedService.clearAllStatus.subscribe((val: boolean) => {
            this.clearAllStatus = val;
        });
        // Picking only the keys that is belonged to the credit check model.
        if (this.customerService.getCustomerModel()) {
            this.creditCheckModel = Object.assign(this.creditCheckModel, _.pick(this.customerService.getCustomerModel(), ...(_.keys(this.creditCheckModel))));
        }
        if(this.customerService.getCustomer() && this.customerService.getCustomer().creditProfile &&
            this.customerService.getCustomer().creditProfile.accountSubType === 'S' && this.customerService.getCustomer().creditProfile.accountType === 'I'){
            this.sharedService.showErrorMessage('_ERR_SOLE_PROPRIETOR', false);
        }

        this.customerService.isEmployee.subscribe(res => {this.isEmployee=res});
        this.customerService.isUnderAge.subscribe(res => {this.isUnderAge=res});

        if(this.creditCheckModel && this.creditCheckModel.errormsg)
        {
            this.isPreScreenFailure = true;
            this.creditCheckModel.yesAuthorize = false;
            this.creditCheckModel.isEnglish = true;
            this.customerModel.isEmployee = true;
        }
        else this.isPreScreenFailure = false;

        this.dormantProperties = this.sharedService.getDormantProperties();
        this.prescreenEnabled = (this.dormantProperties && this.dormantProperties.isPreScreen) ? true : false;
    }

    /**
    * This function is called whenever one or more data-bound input properties change
    * @return {void}
    */
    ngOnChanges(): void {
        console.log('is customer form valid:' + this.customerForm.valid);
        this.customerModel.isValidPIN = (this.customerModel.isValidPIN) ? this.customerModel.isValidPIN : false;
        if (this.customerModel) {
            if (this.customerModel.creditProfile && this.customerModel.creditProfile.creditClass || this.customerModel.altCustomerId) {
                this.disablePIN = true;
                this.customerModel.isValidPIN = true;
                this.customerModel.pin = this.customerModel.creditProfile.identifier;
                this.customerModel.confirmPin = this.customerModel.creditProfile.identifier;
                console.log('Passcode available already for customer: ' + this.customerModel.altCustomerId);
            }
            if(this.customerModel.errorCode) {
                this.customerModel.last4ssn = this.customerModel.creditProfile.last4ssn;
                this.creditCheckModel.ssn3 = this.customerModel.last4ssn;
                this.disableSsn3 = true;
            }
        }
    }

    /**
    * Cleanup just before Angular destroys the directive/component.
    * Unsubscribe Observables and detach event handlers to avoid memory leaks.
    * @return void
    */
    ngOnDestroy(): void {
        const METHOD_NAME: string = 'ngOnDestroy()';
        if (!this.clearAllStatus) {
            this.customerService.setCustomerModel(this.creditCheckModel);
        }
        this.karmaTestResult = null;
        this.customerModel = null;
        this.user = null;
        // this.cart = null; // on page refresh the cart object is getting destroyed so getting the cart again back.
        this.stateItems = null;
        this.idTypeItems = null;
        this.minAllowedDate = null;
        this.maxdate = null;
        // unsubscribing the subscription
        this.subscription.unsubscribe();
    }

    /**
    * This function is used to check the credit eligibility of a customer based on their
    * credit history
    * @return void
    */
    checkEligibility(): void {
        const METHOD_NAME: string = 'checkEligibility()';
        if (this.customerForm.valid) { // checking parent form is valid first
            console.log('[start] - CreditCheckComponent.checkEligibility()>>checking eligibility.');
            this.sharedService.addLogging(this.COMPONENT_NAME, METHOD_NAME, 'Checking credit eligibility');
            const orderId: number = 0;
            if (this.cart) {
                if (this.hasItemsInCart) {
                    this.conflictModel.show();
                } else {
                    this.processCreditCheck(this.cart.orderId);
                }
            } else {
                console.log('Creating a cart for save the customer data.');
                const cartInputData: any = CartUtils.createCartInput(this.storeId, this.user);
                this.sharedService.showSpinner(true); // spinner
                this.cartService.createCartDetails(this.storeId, cartInputData).subscribe(result => {
                    this.karmaTestResult = result;
                    this.sharedService.showSpinner(false); // spinner
                    this.cart = new Cart();
                    this.cart = Object.assign(this.cart, result);
                    // this.cartService.setCart(result);
                    this.processCreditCheck(result.orderId);
                }, error => {
                    this.sharedService.showSpinner(false); // spinner
                    console.error('error=>' + error);
                    this.sharedService.showErrorMessage(error, true);
                });
            }
            console.log('[end] - CreditCheckComponent.checkEligibility()>>checking eligibility.');
        }
    }

    /**
    * This function is used to perform the customer credit check through
    * creditCheck function in customer service
    * @param {number} orderId - order id to refer the order details
    * @return void
    */
    processCreditCheck(orderId: number): void {
        const METHOD_NAME: string = 'processCreditCheck()';
        console.log('CreditCheckComponent.processCreditCheck()>>checking eligibility.');
        const creditCheck: any = new Customer();
        creditCheck.creditProfile = {};
        creditCheck.orderId = orderId;
        creditCheck.firstName = this.customerModel.firstName;
        creditCheck.lastName = this.customerModel.lastName;
        creditCheck.address1 = this.customerModel.address1;
        creditCheck.address2 = this.customerModel.address2;
        creditCheck.city = this.customerModel.city;
        creditCheck.state = this.customerModel.state;
        creditCheck.zipCode = this.customerModel.zipCode;
        creditCheck.middleName = this.customerModel.middleName;
        creditCheck.email1 = this.creditCheckModel.email1;
        if (this.customerModel.hasOwnProperty(Constants.BANNER_MI_DEVICE) &&
            (this.customerModel.middleName !== '') && (this.customerModel.middleName !== undefined)) {
            creditCheck.middleName = this.customerModel.middleName;
        }
        creditCheck.phone1 = Utils.nonFormatPhoneNumber(this.customerModel.phone1);
        creditCheck.dealerCode = this.customerModel.validDealerCode ? this.customerModel.dealerCode : null;
        creditCheck.pin = this.customerModel.pin ? this.customerModel.pin : null;
        if(this.prescreenEnabled) {
        creditCheck.creditProfile.idType = this.creditCheckModel.idType;
        creditCheck.creditProfile.idNumber = this.creditCheckModel.idNumber;
        creditCheck.creditProfile.idIssuedState = this.creditCheckModel.idIssuedState;
        creditCheck.creditProfile.last4ssn = this.customerModel.last4ssn;
        } else {
        creditCheck.idType = this.creditCheckModel.idType;
        creditCheck.idNumber = this.creditCheckModel.idNumber;
        creditCheck.idIssuedState = this.creditCheckModel.idIssuedState;
        }
        if (this.isEmployee) {
            creditCheck.employeeId = this.creditCheckModel.employeeId;
        }
        if (this.creditCheckModel.idExpiration) {
            const dateLatest: string = Utils.nonFormatDate(this.creditCheckModel.idExpiration);
            if(this.prescreenEnabled)
            {
                creditCheck.creditProfile.idExpirationMonth = dateLatest.substring(0, 2);
                creditCheck.creditProfile.idExpirationYear = dateLatest.substring(2,6);
            }
            else{
                creditCheck.idExpirationMonth = dateLatest.substring(0, 2);
                creditCheck.idExpirationYear = dateLatest.substring(2, 6);
            }
        }
        if (!this.creditType || this.creditType === Constants.CREDIT_CHECK) {
            creditCheck.creditType = Constants.CREDIT_CHECK;
            if (this.prescreenEnabled) {
                if (this.creditCheckModel.ssn1 && this.creditCheckModel.ssn2 && this.creditCheckModel.ssn3) {
                    creditCheck.creditProfile.ssn = this.creditCheckModel.ssn1.concat(this.creditCheckModel.ssn2, this.creditCheckModel.ssn3);
                }
            } else {
                const ssnNumber = this.creditCheckModel.ssn;
                if (this.sharedService.checkFormat(ssnNumber)) {
                    creditCheck.ssn = Utils.nonFormatSSN(ssnNumber);
                } else if (this.isEmployee) {
                    creditCheck.ssn = this.creditCheckModel.ssn;
                }
            }
        } else {
            creditCheck.creditType = Constants.NOCREDIT_CHECK;
        }
        //added for smart credit and passing values to creditcheck api irrrespective of credit type
        if(this.customerModel.eligibility === 'y' ) {
                creditCheck.accountNumber = this.customerModel.accountNumber;
                creditCheck.brandType = this.customerModel.brandType;
                creditCheck.eligibility = this.customerModel.eligibility;
                creditCheck.eligibilityDate = this.customerModel.eligibilityDate;
                creditCheck.paymentCount = this.customerModel.paymentCount;
                creditCheck.nonTMOMobileNumber = this.customerModel.nonTMOMobileNumber.replace(new Â RegExp('-', Â 'g'), Â '');
                creditCheck.nonTMOMobilePin = this.customerModel.nonTMOMobilePin;
        }
        if (this.customerModel.dateOfBirth) {
            this.dob=this.customerModel.dateOfBirth;
            let dateLatest: string = Utils.nonFormatDate(this.customerModel.dateOfBirth);
            if(this.prescreenEnabled)
            {
                creditCheck.dateOfBirth = dateLatest.substring(4, 8) + '-' + dateLatest.substring(0, 2) + '-' + dateLatest.substring(2, 4);
            }
            else
            {
            creditCheck.birthDate = dateLatest.substring(2, 4);
            creditCheck.birthMonth = dateLatest.substring(0, 2);
            creditCheck.birthYear = dateLatest.substring(4, 8);
            }
        }
        this.sharedService.showSpinner(true); // spinner
        const inputData: any = CartUtils.validateAddressInput(creditCheck);
        this.customerService.validateAddress(this.storeId, inputData).subscribe(result => {
            this.karmaTestResult = result;
            this.sharedService.showSpinner(false); // spinner
            if (result.statusCode === Constants.ORDER_STATUS_S) {
                creditCheck.address1 = this.customerModel.address1 = result.addressLine1;
                creditCheck.address2 = this.customerModel.address2 = result.addressLine2;
                creditCheck.city = this.customerModel.city = result.city;
                creditCheck.state = this.customerModel.state = result.stateCode;
                creditCheck.zipCode = this.customerModel.zipCode = Utils.trimZipCode(result.zipCode);
                this.sharedService.showSpinner(true); // spinner
                this.customerService.creditCheck(this.storeId, creditCheck).subscribe(creditCheckResult => {
                    this.karmaTestResult = creditCheckResult;
                    this.sharedService.showSpinner(false); // spinner
                    // creditCheckResult.errorCode = '';
                    // creditCheckResult.errorMessage = '';
                    if (this.dormantProperties && this.dormantProperties.isPreScreen && creditCheckResult && (creditCheckResult.errorCode == '_ERR_PRESCREEN_FAILED_NO_MATCHING_DATA'
                        || creditCheckResult.errorCode == '_ERR_PRESCREEN_FAILED_DEALER_CODE_INVALID')) {
                        //this.creditCheckModel.errorCode = creditCheckResult.errorCode;
                        this.creditCheckModel.errormsg = creditCheckResult.errorMessage;
                    }
                    creditCheck.dateOfBirth=this.dob;
                    // clearing customer data from customer service.
                    this.customerService.setCustomer(null);
                    creditCheck.eligibilityMsg = this.customerModel.eligibilityMsg;
                    creditCheck.isValidated = this.customerModel.isValidated;
                    creditCheck.isPromoEligibleZipCode = (this.customerModel.isPromoEligibleZipCode) ? this.customerModel.isPromoEligibleZipCode : false;
                    creditCheck.errorCode = this.creditCheckModel.errorCode;
                    creditCheck.errorMessage = this.creditCheckModel.errormsg;
                    this.cart.customer = Object.assign(creditCheck, creditCheckResult);
                    this.cartService.setCart(this.cart);
                    if (this.dormantProperties && this.dormantProperties.isPreScreen && creditCheckResult && !creditCheckResult.errorCode) {
                        this.customerService.createCustomer(this.storeId, this.cart.customer).subscribe(createCustomerResult => {
                            this.sharedService.showSpinner(false); // spinner
                            this.cart.customer.addressId = createCustomerResult.addressId;
                            this.cartService.setCart(this.cart);
                        }, error => {
                            this.sharedService.showSpinner(false); // spinner
                            this.sharedService.showErrorMessage(error, true);
                        });
                    }
                    this.sharedService.updateCreditChoice(creditCheckResult.creditType);
                    if (this.cart && this.cart.customer && this.cart.customer.creditProfile && this.cart.customer.creditProfile.isExistingCustomer) {
                        this.sharedService.showErrorMessage('_ERR_CUSTOMER_CREDIT_CHECK_ALREADY_DONE', false);
                    }
                    if (this.cart.packages && this.cart.packages.length > 0) {
                        this.removeConflicts();
                    }
                }, error => {
                    this.sharedService.showSpinner(false); // spinner
                    this.sharedService.showErrorMessage(error, true);
                    console.error('error=>' + error);
                });
            } else {
                this.sharedService.showErrorMessage('_ERR_INVALID_ADDRESS', false);
            }
        }, error => {
            this.sharedService.showSpinner(false); // spinner
            this.sharedService.showErrorMessage(error, true);
            // console.error('validate address error=>'+ error)
        });
    }

    /**
     * This function is used to resolve conflicts
     * @returns void
     */
    resolveConflicts(): void {
        const METHOD_NAME: string = 'resolveConflicts()';
        this.hasItemsInCart = false;
        this.conflictModel.hide();
        this.checkEligibility();
    }

    /**
    * This function is used to resolve the conflicted data after
    * the process credit check
    * @return void
    */
    removeConflicts(): void {
        const METHOD_NAME: string = 'removeConflicts()';
        const inputData: any = { 'resolveType': 'NEW' };
        this.sharedService.showSpinner(true); // spinner
        this.cartService.resolveConflicts(this.storeId, this.cart.orderId, inputData).subscribe(result => {
            this.karmaTestResult = result;
            this.cartService.getCartSummary(this.storeId, this.cart.orderId).subscribe(getCartSummaryResult => {
                this.sharedService.showSpinner(false); // spinner
                this.cartService.setCart(Object.assign(this.cart, getCartSummaryResult));
            }, error => {
                this.sharedService.showSpinner(false); // spinner
                this.sharedService.showErrorMessage(error, true);
                console.error('error=>' + error);
            });
        }, error => {
            this.sharedService.showSpinner(false); // spinner
            console.error('error=>' + error);
            this.sharedService.showErrorMessage(error, true);
        });
    }

    /**
     * This function is used for clearing the form elements
     * @returns void
     */
    resetCreditCheck(frm: NgForm): void {
        const METHOD_NAME: string = 'resetCreditCheck()';
        if (!this.disablePIN) {
            if (!this.cart) {
                this.customerForm.reset();
                this.onResetForm.emit();

                if (this.customerModel.creditType && this.customerModel.creditType === Constants.NOCREDIT_CHECK) {
                    this.customerForm.form.controls.creditType.setValue(Constants.NOCREDIT_CHECK);
                } else {
                    this.customerForm.form.controls.creditType.setValue(Constants.CREDIT_CHECK);
                }
                if(this.customerForm.form.controls.isEmployee){
                    this.customerForm.form.controls.isEmployee.setValue(false);
                }
            }
            frm.form.reset();
            this.creditCheckModel = { idExpiration: '', idIssuedState: '', idNumber: '', idType: '',isEnglish: true,
                     yesAuthorize: false, employeeId: '', isEmployee: false};
            if(frm.form.controls.isEnglish) {
                frm.form.controls.isEnglish.setValue(true);
            }
            if(frm.form.controls.yesAuthorize) {
                frm.form.controls.yesAuthorize.setValue(false);
            }
            frm.form.controls.idType.reset();
            frm.form.controls.idType.setValue('');
            frm.form.controls.idState.reset();
            frm.form.controls.idState.setValue('');
            this.isEmployee=false;
            this.isUnderAge = false;
            this.customerModel.disable4ssn = false;
            this.customerService.setCustomerModel(null);
            this.customerService.setIsEmployeeData(false);
        } else if (this.disablePIN) {
            if (frm.form.controls.ssn) {
                frm.form.controls.ssn.reset();
            }
            if (frm.form.controls.ssn1) {
                frm.form.controls.ssn1.reset();
            }
            if (frm.form.controls.ssn2) {
                frm.form.controls.ssn2.reset();
            }
            // if (frm.form.controls.ssn3) {
            //     frm.form.controls.ssn3.reset();
            // }
            if (frm.form.controls.employeeId) {
                frm.form.controls.employeeId.reset();
            }
            frm.form.controls.idType.reset();
            frm.form.controls.idType.setValue('');
            frm.form.controls.idState.reset();
            frm.form.controls.idState.setValue('');
            frm.form.controls.idNumber1.reset();
            frm.form.controls.idExpiration.reset();
            frm.form.controls.idExpiration.setValue('');
            frm.form.controls.email1.reset();
            frm.form.controls.email1.setValue('');            
            frm.form.controls.yesAuthorize.setValue(false);
            this.isEmployee = false;
            this.isUnderAge = false;
            //frm.form.controls.isEmployee.setValue(false);
            this.customerService.setIsEmployeeData(false);
            frm.form.controls.isEnglish.setValue(true);

        }
    }
    /**
    * This function is used set the state as empty when selected id type US Alien ID
    * @param {any} idSelected - contains the selected ID
    * @returns void
    */

    idTypeChanged(idSelected: any): void {
        if (idSelected === 'ALIE' || idSelected === 'MILI') {
            this.creditCheckModel.idIssuedState = '';
        }
    }
}